__turbopack_context__.v({
  "bookingCol": "quoteBooking-module__1DJn3W__bookingCol",
  "detailRow": "quoteBooking-module__1DJn3W__detailRow",
  "grid": "quoteBooking-module__1DJn3W__grid",
  "infoCol": "quoteBooking-module__1DJn3W__infoCol",
  "priceBadge": "quoteBooking-module__1DJn3W__priceBadge",
  "quoteCard": "quoteBooking-module__1DJn3W__quoteCard",
  "scheduleBlock": "quoteBooking-module__1DJn3W__scheduleBlock",
  "serviceHeader": "quoteBooking-module__1DJn3W__serviceHeader",
  "serviceTitle": "quoteBooking-module__1DJn3W__serviceTitle",
});
